/**
 * 接口地址
 */

/**
 * 列表示例接口
 */
export const EXAMPLE_LIST = '/mock/list'; // 列表接口
export const EXAMPLE_LIST_EMPTY = '/mock/emptyList'; // 空列表接口

/** CS66 商户服务费订单 */
export const CS66_ORDER_LIST = '/xlm-app/nologin/cs66/orders';
export const CS66_ORDER_DETAIL = (bizType, bizNo) =>
  `/xlm-app/nologin/cs66/orders/${encodeURIComponent(bizType)}/${encodeURIComponent(bizNo)}`;

export const MEETING_DATAILS = '/xlm-activity/meeting/getMeetingDetail';

export const ADDRESS_PROV = '/xlm-app/systemManage/getProvinceList';

export const MEETING_GET_LIST = `/xlm-activity/meeting/getMeetingList`;

export const MEETING_UPDATESTATUS = '/xlm-activity/meeting/updateStatusByMeetingId';

export const MEETING_CREATE = '/xlm-activity/meeting/userCreate';

export const MEETING_UPDATE = '/xlm-activity/meeting/updateMeeting';

export const MEETING_ENROLL = '/xlm-activity/record/enroll';

export const MEETING_APPLY_INFO = '/xlm-activity/record/getMeetingApplyInfo';

export const MEETING_SIGN_INFO = '/xlm-activity/record/getMeetingSignInInfo';

export const ADDRESS_CITY = '/xlm-app/systemManage/getCityList/';

export const ADDRESS_COUNTRY = '/xlm-app/systemManage/getDistrictList/';

export const MEETING_GET_MINE = `/xlm-activity/meeting/getOwnerMeeting`;

export const MEETING_GET_USERLEVEL = `/xlm-activity/meeting/getUserLevel`;

export const MEETING_OFFICE_LEADER = '/xlm-app/activity/checkOfficeLeader';

export const MEETING_SIGN = id => `/xlm-activity/record/signIn?meetingId=${id}`;

/** 会议数据 排行榜 */
export const getMeetingRankListUrl = `/xlm-activity/meeting/getMeetingRankList`;

/** 会议数据 会议产出 */
export const getMeetingProdRatioTabUrl = `/xlm-activity/meeting/getMeetingProdRatioTab`;

/** 会议数据 会后效果 */
export const getMeetingIncRatioUrl = `/xlm-activity/meeting/getMeetingIncRatio`;

/** 会议排行榜 */
export const GET_MEETING_RANKING = `/xlm-activity/meetingRank/selectList`;

/**
 * 申请归属
 */
export const BELONG_APPLY = '/xlm/login/noRCode/submit';

/**
 * 申请归属发送短息验证码
 */
export const BELONG_SENDCODE = '/xlm/login/noRCode/sendCode';
/** 去实名认证 */
export const AUTH_INFO = `/xlm/user/auth/authInfo`;

/** 去绑定结算卡 */
export const CARD_FIND = `/xlm/user/info/V401/find`;

/** 是否首次激活 */
export const HAS_MER_ACTIVE = `/xlm-refactor/event/newcomer/task/hasMerActive`;

/** 是否 考试 */
export const TEST_STATUS_CHECK = `/xlm-refactor/event/v1/exam/examStatusCheck`;

/** 是否 电子签章*/
export const SIGN_PROTOCOL = `/xlm/tsign/pointSignProtocol`;

export const ELECTRIC_SALES = `/xlm/tsignForElectricSales/pointSignProtocol`;

/** 是否 加入工作室 */
export const JOIN_STUDIO = id => `/xlm/isJoinedOfficeByMemberUserId?memberUserId=${id}`;

/** 是否 设置兴趣目标 */
export const SURVEY_SELECT = '/xlm-activity/survey/select';

/** 保存 调研 */
export const SURVEY_ADD = '/xlm-activity/survey/add';

/** 查询本月用户目标 */
export const INCOME_SELECT = '/xlm-activity/income/select';

/** 修改本月用户目标 */
export const INCOME_UPDATE = '/xlm-activity/income/update';

/**
 * 注册验证码
 */
export const REGISTER_CODE = '/xlm-app/register/sendCode';

/** 获取推荐人信息 */
export const LOGIN_SHARE_PARAM = `/xlm/login/loginShareParam `;

/** 年终账单 */
export const BILL_REPORT = '/xlm-refactor/ally/annualStatement/getReport';

/**
 *  注册
 * @type {string}
 */
export const REGISTER = '/xlm-app/register/appRegisterAndLogin';

/** 地推王排行榜日榜 */
export const GET_ACTIVE_DAY = '/xlm-refactor/event/activateRanking/queryDayList';

/** 地推王排行榜周榜 */
export const GET_ACTIVE_WEEK = '/xlm-refactor/event/activateRanking/queryWeekList';

/** 地推王排行榜月榜 */
export const GET_ACTIVE_MONTH = '/xlm-refactor/event/activateRanking/queryMonthList';

/**
 *  获取知识库banner
 */
export const KNOWLEDGE_GET_BANNER = '/xlm-activity/banner/list';

/**
 * 查询知识库标签
 */
export const KNOWLEDGE_GET_LABEL = '/xlm-activity/knowledgeLabel/getAllLabel';

/**
 * 查询知识库资讯
 */
export const KNOWLEDGE_GET_INFO = '/xlm-activity/knowledgeInfo/getInfo';

/**
 * 统计资讯点击次数
 */
export const KNOWLEDGE_SUM_CLICK = '/xlm-activity/knowledgeInfo/recordTimes';

/* 资格认证列表 */
export const KNOWLEDGE_AUTH_LIST = '/xlm-activity/certification/selectList';

/* 资格认证详情 */
export const KNOLEDGE_DETAIL_INFO = '/xlm-activity/certification/selectDetail';

/* 资格认证考试开始 */
export const KNOLEDGE_AUTH_TEST_START = '/xlm-activity/exam/startExam';
export const KNOLEDGE_AUTH_TEST_END = '/xlm-activity/exam/endExam';

/**
 * 新手任务相关
 */
/* 是否显示新手任务 */
export const IS_SHOW_TASK = '/xlm-activity/task/isShowTask';

/* 新手任务列表 */
export const TASK_LIST = '/xlm-activity/task/selectList';

/* 新手任务列表（新） */
export const NEWBIT_TASK_LIST = '/xlm-activity/task/selectListNew';

/* 查询分公司 */
export const GET_BRANCH_LIST = '/xlm-activity/meeting/findLandBranchList';

/* 小鹅通登录 */
export const XET_LOGIN = '/xlm-activity/xiaoETong/getLoginUrl';

/* 百强争霸 */
export const ONE_HUNDRED_TOURNAMENT = '/xlm/studioGroupActivities/selectOneHundredTournament';

/* 全国冲刺赛 */
export const COUNTRY_RUSH = '/xlm/studioGroupActivities/selectNationalActiveSprint';

/* 省内冲刺赛 */
export const PROVINCE_RUSH = '/xlm/studioGroupActivities/selectProvinceActiveSprint';

/* 发送短信验证码 */
export const SEND_CODE = '/xlm-app/common/sms/sendCodeV12885521';

/* 企业微信绑定鑫联盟账号 */
export const WORK_WECHAT_BIND = '/xlm-app/nologin/workWeiXin/bind';

/* 企业微信登录 */
export const WORK_WECHAT_LOGIN = '/xlm-app/nologin/workWeiXin/login';

/* 查询有效活动列表 */
export const FIND_VALID_ACTIVITIES = '/xlm-app/brandActivity/findValidActivities';

/* 查询单个活动 */
export const FIND_ACTIVITY_BY_ID = '/xlm-app/brandActivity/findActivityById';

/**
 * 讲武堂活动
 */
export const JIANGWUTANG_ACTIVITY_LIST = '/xlm-app/jiangwutang/activities';
export const JIANGWUTANG_ACTIVITY_DETAIL = id => `/xlm-app/jiangwutang/activities/${id}`;
export const JIANGWUTANG_ACTIVITY_RESERVE = id => `/xlm-app/jiangwutang/activities/${id}/reserve`;
export const JIANGWUTANG_ACTIVITY_PAYMENT_INFO = id =>
  `/xlm-app/jiangwutang/activities/${id}/payment-info`;
export const JIANGWUTANG_ACTIVITY_INVITATION_INFO = id =>
  `/xlm-app/jiangwutang/activities/${id}/invitation-info`;

/* 查询荣耀保卫战小组信息详情 */
export const GET_STUDIO_DEFENCE_DETAIL = '/xlm/salesGuardHonourRecord/guardHonourActivityInfo';

/* 月满中秋活动排行榜 */
export const ZHONGQIU_ACTIVITY_LIST = '/xlm/studioGroupActivities/getMidAutumnFestivalRanking';

/**
 * 工作室素材库相关
 */
export const GET_STUDIO_MATERIAL_CATEGORY = '/xlm/materialLibrary/category'; // 获取分类
export const GET_STUDIO_TOP_ARTICLE = '/xlm/materialLibrary/topArticle'; // 推荐文章
export const GET_STUDIO_ARTICLE_LIST = '/xlm/materialLibrary/articleList'; // 文章列表
export const GET_ARTICLE_DETAILS = '/xlm/materialLibrary/articleDetails'; // 文章详情
export const LIKE_ARTICLE = '/xlm/materialLibrary/likeArticle'; // 文章点赞
export const STUDIO_MATERIAL_SEARCH = '/xlm/materialLibrary/search'; // 搜索
export const STUDIO_COPY_PHRASE = '/xlm/materialLibrary/copyPhrase'; // 复制
export const STUDIO_GET_POSTER = '/xlm/materialLibrary/posterList'; // 海报列表
export const STUDIO_GET_POSTER_DETAIL = '/xlm/materialLibrary/posterDetails'; // 海报详情
export const GET_STUDIO_SPEECH = '/xlm/materialLibrary/phrase'; // 话术库
export const ADD_POSTER_DOWNLOAD = '/xlm/materialLibrary/downloadPoster'; // 增加下载次数
export const GET_GOOD_POSTER = '/xlm/materialLibrary/recommendPoster'; // 获取推荐海报
export const GET_ARTICLE_FORWARD = '/xlm/materialLibrary/forwardArticle'; //文章转发数

/**
 * 获取祝福语
 */
export const GET_GREETING = '/xlm-activity/nologin/getGreeting2';

/* 月度报告列表*/
export const GET_REPORT_MONTH_LIST = '/xlm-activity/reportMonth/reportMonthList';

/* 月度报告*/
export const GET_REPORT_MONTH = '/xlm-activity/reportMonth/reportMonth';

/* 产品资料详情*/
export const GET_INTER_DETAILS = '/xlm-activity/interlocutor/getDetails';

/* 产品资料详情 分享*/
export const GET_INTER_SHARE = '/xlm-activity/interlocutor/shareProduct';

/* 查询管家复核用户信息列表 */
export const GET_AUDIT_USER_INFO_LIST = '/cps-market/installInvitation/queryAuditUserInfoList';

/* 复核用户信息 */
export const DO_AUDIT_USER_INFO = '/cps-market/installInvitation/doAuditUserInfo';

/* 查询复核用户信息详情 */
export const GET_AUDIT_USER_INFO_DETAIL = '/cps-market/installInvitation/getAuditUserInfoDetail';

/*获取广告信息（多条） */
export const GET_ADVERTISEMENT_INFO_BY_LIST =
  '/xlm-activity/advertisement/getAdvertisementInfoByList';

/*新人快速入门点赞 */
export const GET_ADVERTISEMENT_Like = '/xlm-activity/advertisement/like';

/* 接受代缴申请 */
export const ACCEPT_PAY_REQUEST = '/xlm-data/simfee/simFee/acceptPayRequest';

/* 校验缴费能力 */
export const CHECK_PAYABLE = '/xlm-data/simfee/simFee/checkPayable';

/* 发起代缴申请 */
export const CREAT_PAY_REQUEST = '/xlm-data/simfee/simFee/createPayRequest';

/* 本人服务费缴费 */
export const CREAT_SELF_PAY = '/xlm-data/simfee/simFee/createSelfPay';

/* 发起或复用流量卡续费协议签署流程 */
export const CREATE_RENEW_SIGN_FLOW = '/xlm-data/simfee/simFee/createRenewSignFlow';

/* 帮他人代缴详情展示 */
export const GET_BEHALF_SIM_FEE_INFO = '/xlm-data/simfee/simFee/getBehalfSimFeeInfo';

/* 帮他人代缴列表 */
export const GET_BEHALF_SIM_FEE_LIST = '/xlm-data/simfee/simFee/getBehalfSimFeeList';

/* 查询 个人/他人代缴 续费详情 */
export const GET_RENEW_DETAIL = '/xlm-data/simfee/simFee/getRenewDetail';

/* 查询 个人/他人代缴 续费记录 */
export const GET_RENEW_RECORDS = '/xlm-data/simfee/simFee/getRenewRecords';

/* 查询流量卡续费协议签署状态 */
export const QUERY_RENEW_SIGN_STATUS = '/xlm-data/simfee/simFee/queryRenewSignStatus';

/* 获取流量卡续费列表 */
export const GET_SIM_FEE_LIST = '/xlm-data/simfee/simFee/getSimFeeList';

/* 拒绝代缴申请 */
export const REFUSE_PAY_REQUEST = '/xlm-data/simfee/simFee/refusePayRequest';

/* 撤销代缴申请 */
export const REVOKE_PAY_REQUEST = '/xlm-data/simfee/simFee/revokePayRequest';

/* 发送短信验证码 */
export const SEND_SMS_CODE = '/xlm-data/simfee/simFee/sendSmsCode';
/* 衰退相关 */
// 管家名下商户核销优惠券明细列表
export const GET_COUPON_LIST = '/xlm-app/merchantCouponVer/getMerchantCouponVerDetailList';
// 查询管家名下商户未核销优惠券明细列表
export const GET_COUPON_UNVER_LIST = '/xlm-app/merchantCouponVer/getMerchantCouponUnVerDetailList';
// 管家名下商户核销优惠券汇总
export const GET_SUMMARY_INFO = '/xlm-app/merchantCouponVer/getMerchantCouponVerSummaryInfo';
// 优惠券详情
export const GET_COUPON_DETAIL = '/xlm-app/merchantCouponVer/getMerchantCouponVerDetailInfo';
// 查询未核销优惠券分享链接信息
export const GET_COUPON_SHARE_INFO = '/xlm-app/merchantCouponVer/getMerchantCouponUnVerShareInfo';
// 查询平台助力业绩汇总
export const GET_ACT_PERFORMANCE_SUMMARY_INFO =
  '/xlm-app/merchantCouponVer/getActPerformanceSummaryInfo';
// 查询平台助力业绩列表
export const GET_ACT_PERFORMANCE_LIST_INFO = '/xlm-app/merchantCouponVer/getActPerformanceListInfo';

// 活动是否已报名
export const IS_RESIGTERATION = '/cps-market/incentiveRegistration/isRegistration';

// 报名按钮
export const REGIST_BUTTON = '/cps-market/incentiveRegistration/registButton';

// 报名按钮
export const ACTIVE_REGISTRANTION = '/cps-market/incentiveRegistration/activRegistration';

// 分货指定分红-查询团队中可以划拨的管家列表
export const GET_ASSIGN_USER_LIST = '/xlm-activity/targetPurchase/getAssignUserList';
// 分货指定分红-指定分红
export const DESIGNTED_DEVIDEND = '/xlm-activity/targetPurchase/designatedDividend';
// 分货指定分红-查询已经分货的管家信息
export const GET_ASSIGNED_USER = '/xlm-activity/targetPurchase/getAssignedUser';
// 分货指定分红-查询可以划拨的机器数
export const GET_ASSIGN_DEVICE_NUM = '/xlm-activity/targetPurchase/getAssignDeviceNum';
// 个人晋升奖-判断活动参与条件
export const GRADE_UP_CHECK_GONDITION = '/xlm-data/gradeUp/checkCondition';
// 个人晋升奖-获取个人晋升页面数据
export const GRADE_UP_GET_GRADE_UP_DATA = '/xlm-data/gradeUp/getGradeUpData';
// 交易净增-查询我的活动信息
export const TRAN_INCREASE_QUERY_MY_INFO = '/xlm-data/tranIncrease/queryMyInfo';
// 交易净增-查询排行榜单信息
export const TRAN_INCREASE_QUERY_BANK_INFO = '/xlm-data/tranIncrease/queryRankInfo';
// 定向培养-查询报名人信息
export const DIRECT_FIND_DIRECT_ACTIVE_USER = '/xlm-data/direct/findDirectActiveUser';
// 定向培养-查询培养中断名单
export const DIRECT_FIND_INTERUPT_LIST = '/xlm-data/direct/findInteruptList';
// 定向培养-查询培养成功名单
export const DIRECT_FIND_ORDER_OFFER_LIST = '/xlm-data/direct/findOfferList';
// 定向培养-查询培养储备名单
export const DIRECT_FIND_RESERVE_LIST = '/xlm-data/direct/findReserveList';
// 金牌育成-获取金牌育成页面数据
export const GRADE_UP_GET_GOLD_MEDAL_BREED_DATA = '/xlm-data/gradeUp/getGoldMedalBreedData';
// 金牌育成-获取育成v5名单
export const GRADE_UP_GET_BREED_V5_LIST = '/xlm-data/gradeUp/getBreedV5List';
// 激活达标奖励-查询待结算余额
export const GET_TO_BE_SETTLED_TOTAL_AMT = '/xlm-app/realTimeSettle/getToBeSettledTotalAmt';
// 激活达标奖励-查询余额变动明细
export const GET_SETTLE_ACTION_LOG_LIST = '/xlm-app/realTimeSettle/getSettleActionLogList';
// 激活达标奖励-申请结算
export const APPLY_SETTLE_REWARD = '/xlm-app/realTimeSettle/applySettleReward';
// 默认结算卡
export const QUERY_SETTLEMENT_CARDS = '/xlm-app/user/card/querySettlementCards';
// 激活达标奖励-确认结算
export const CONFIRM_SETTLE_REWARD = '/xlm-app/realTimeSettle/confirmSettleReward';
// 激活达标奖励-查询结算单列表
export const GET_SETTLE_LIST = '/xlm-app/realTimeSettle/getSettleList';
// 激活达标奖励-重新申请付款
export const RE_APPLY_SETTLE_REWARD = '/xlm-app/realTimeSettle/reApplySettleReward';
// 激活达标奖励-查询结算单详情
export const GET_SETTLE_DETAIL = '/xlm-app/realTimeSettle/getSettleDetail';
// 激活达标奖励-校验实时结算开关
export const CHECK_REAL_TIME_SETTLE_SWITCH = '/xlm-app/realTimeSettle/checkRealTimeSettleSwitch';
// 查询钱包状态
export const WHETHER_OPEN_ACCOUNT = '/xlm-app/user/wallet/whetherOpenAccount';
// 办卡-获取当前余额
export const GET_BALANCE = '/zee-card/zee/card/incentiveSettle/getBalance';
// 办卡-获取奖励结算列表
export const GET_INCENTIVE_LIST = '/zee-card/zee/card/incentiveSettle/getIncentiveList';
// 办卡-获取奖励结算订单列表
export const GET_SETTLE_ORDER_LIST = '/zee-card/zee/card/incentiveSettle/getSettleOrderList';
// 办卡-获取奖励结算汇总信
export const GET_SUMMARY_INCENTIVE = '/zee-card/zee/card/incentiveSettle/getSummaryIncentive';
// 办卡-获取奖励结算订单结果
export const GET_SETTLE_ORDER_RESULT = '/zee-card/zee/card/incentiveSettle/getSettleOrderResult';
// 办卡-重新提交奖励结算
export const RESUBMIT_SETTLE_INCENTIVE =
  '/zee-card/zee/card/incentiveSettle/resubmitSettleIncentive';
// 办卡-奖励结算
export const SETTLE_INCENTIVE = '/zee-card/zee/card/incentiveSettle/settleIncentive';

// 营销奖励日结接口
export const MARKETING_REWARD_GET_BALANCE = '/xlm-app/marketing-reward/account/balance'; // 查询余额
export const MARKETING_REWARD_GET_CHANGE_LIST = '/xlm-app/marketing-reward/account/change-list'; // 查询余额变动明细
export const MARKETING_REWARD_GET_SETTLE_LIST =
  '/xlm-app/marketing-reward/account/settle-bill/list'; // 查询结算单列表
export const MARKETING_REWARD_GET_SETTLE_DETAIL =
  '/xlm-app/marketing-reward/account/settle-bill/detail'; // 查询结算单详情
export const MARKETING_REWARD_RETRY_PAYMENT = '/xlm-app/marketing-reward/settle/retry-payment'; // 重新付款
export const MARKETING_REWARD_GET_SUMMARY = '/xlm-app/marketing-reward/account/getSummaryIncentive'; // 结算前汇总信息（银行卡、费用明细）
export const MARKETING_REWARD_SETTLE = '/xlm-app/marketing-reward/settle/apply'; // 确认结算申请
export const MARKETING_REWARD_GET_SUMMARY_INCENTIVE =
  '/xlm-app/marketing-reward/account/getSummaryIncentive'; // 获取奖励结算汇总信息（参考办卡接口）

// 增值奖励日结接口
export const ADDED_REWARD_GET_BALANCE = '/xlm-app/added-reward/account/balance';
export const ADDED_REWARD_GET_CHANGE_LIST = '/xlm-app/added-reward/account/change-list';
export const ADDED_REWARD_GET_SETTLE_LIST = '/xlm-app/added-reward/account/settle-bill/list';
export const ADDED_REWARD_GET_SETTLE_DETAIL = '/xlm-app/added-reward/account/settle-bill/detail';
export const ADDED_REWARD_GET_SUMMARY = '/xlm-app/added-reward/account/getSummaryIncentive';
export const ADDED_REWARD_SETTLE = '/xlm-app/added-reward/settle/apply';
export const ADDED_REWARD_RETRY_PAYMENT = '/xlm-app/added-reward/settle/retry-payment';

// 活动-月度直营激活
export const GET_Q2_ACTIVITY1 = '/xlm-app/undertakingQuery/getQ2Activity1';
// 活动-管家申请机具达标参与旅行活动
export const GET_Q2_ACTIVITY2 = '/xlm-app/undertakingQuery/getQ2Activity2';
// 活动-T队申请机具奖励
export const GET_Q2_ACTIVITY3 = '/xlm-app/undertakingQuery/getQ2Activity3';
// 活动-T队激活净增
export const GET_Q2_ACTIVITY4 = '/xlm-app/undertakingQuery/getQ2Activity4';
// 活动-管家申请机具达标参与旅行活动二期
export const GET_Q2_ACTIVITY5 = '/xlm-app/undertakingQuery/getQ2Activity5';
// 活动-T队激活净增二期
export const GET_Q3_ACTIVITY6 = '/xlm-app/undertakingQuery/getQ3Activity6';
// 鑫动5+5-查询任务状态
export const XINFF_ACTIVITY_STATUS = '/xlm-app/xinff/activities/status';
// 鑫动5+5-领取奖励
export const XINFF_ACTIVITY_CLAIM = '/xlm-app/xinff/activities/claim';
// 活动-Q3团队采购奖励
export const GET_Q3_TEAM_PURCHASE_ACTIVITY = '/xlm-app/undertakingQuery/getQ3TeamPurchaseActivity';

// CS66 活动进度
export const CS66_AGENT_ACTIVITY = '/xlm-app/cs66/activity';
export const CS66_MERCHANT_ACTIVITY = '/xlm-app/cs66/activity';
// 活动-Q4团队采购奖励
export const GET_Q4_TEAM_PURCHASE_ACTIVITY = '/xlm-app/undertakingQuery/getQ4TeamPurchaseActivity';
// 活动-Q4T队激活净增
export const GET_Q4_ACTIVITY4 = '/xlm-app/undertakingQuery/getQ4TeamActivationActivity';
// 活动-Q4采购领门票
export const GET_Q4_LIMITED_PURCHASE = '/xlm-app/undertakingQuery/getQ4LimitedPurchaseActivity';
